export default "__VITE_ASSET__DM6i32z0__"